import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, DatePicker } from 'antd';
import moment from 'moment';
import { createPhysicianItems, updatePhysicianItems } from 'services/settings/lookup_table/physician';

const PhysicianForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate, maxPhysicianSort }) => {
	const onFinish = async values => {
		console.log(values);

		const payload = {
			physicianPrefix: values.physicianPrefix || null,
			physicianFirstName: values.physicianFirstName,
			physicianMiddleName: values.physicianMiddleName || null,
			physicianLastName: values.physicianLastName,
			physicianSuffix: values.physicianSuffix || null,
			physicianDegree: values.physicianDegree || null,
			physicianLicenseNo: values.physicianLicenseNo || null,
			physicianValidity: values.physicianValidity ? values.physicianValidity.format('YYYY-MM-DD') : null,
			isActive: values.active === true ? 1 : 0,
			// For UPDATE: keep existing sort, For CREATE: use maxPhysicianSort + 1
			physicianSort: selecetedData ? selecetedData.physicianSort : (maxPhysicianSort ? maxPhysicianSort + 1 : 1),
		};

		console.log(payload);

		if (buttonNames === 'ADD') {
			const created = await createPhysicianItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			payload.physicianID = selecetedData.physicianID;
			const updated = await updatePhysicianItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					physicianPrefix: selecetedData ? selecetedData.physicianPrefix : '',
					physicianFirstName: selecetedData ? selecetedData.physicianFirstName : '',
					physicianMiddleName: selecetedData ? selecetedData.physicianMiddleName : '',
					physicianLastName: selecetedData ? selecetedData.physicianLastName : '',
					physicianSuffix: selecetedData ? selecetedData.physicianSuffix : '',
					physicianDegree: selecetedData ? selecetedData.physicianDegree : '',
					physicianLicenseNo: selecetedData ? selecetedData.physicianLicenseNo : '',
					physicianValidity: selecetedData && selecetedData.physicianValidity
						? moment(selecetedData.physicianValidity)
						: null,
					active: selecetedData ? (selecetedData.isActive === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="active" valuePropName="checked">
							<Switch disabled={buttonNames === 'ADD'} />
						</Form.Item>
					</Col>
				</Row>

				<Form.Item
					label="PREFIX"
					name="physicianPrefix"
				>
					<Input maxLength={254} placeholder="Dr., Mr., Ms., etc." />
				</Form.Item>

				<Form.Item
					label="FIRST NAME"
					name="physicianFirstName"
					rules={[{ required: true, message: 'First Name is required' }]}
				>
					<Input maxLength={254} />
				</Form.Item>

				<Form.Item
					label="MIDDLE NAME"
					name="physicianMiddleName"
				>
					<Input maxLength={254} />
				</Form.Item>

				<Form.Item
					label="LAST NAME"
					name="physicianLastName"
					rules={[{ required: true, message: 'Last Name is required' }]}
				>
					<Input maxLength={254} />
				</Form.Item>

				<Form.Item
					label="SUFFIX"
					name="physicianSuffix"
				>
					<Input maxLength={254} placeholder="Jr., Sr., III, etc." />
				</Form.Item>

				<Form.Item
					label="DEGREE"
					name="physicianDegree"
				>
					<Input maxLength={254} placeholder="MD, DO, PhD, etc." />
				</Form.Item>

				<Form.Item
					label="PHYSICIAN LICENSE NO"
					name="physicianLicenseNo"
					rules={[{ required: true, message: 'License no. is required' }]}
				>
					<Input maxLength={254} />
				</Form.Item>

				<Form.Item
					label="VALIDITY"
					name="physicianValidity"
					rules={[{ required: true, message: 'Validity is required' }]}
				>
					<DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
				</Form.Item>

				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default PhysicianForm;
